// extracted by mini-css-extract-plugin
export const tag = "Tag-module--tag--3NkJ9";
export const mission = "Tag-module--mission--1wYRR";
export const component = "Tag-module--component--2rQTT";